import { Activity as ActivityComponent } from '@components/Activity/Activity'

export const Activity = () => {
  return <ActivityComponent />
}
